export var COMPILER_DEFAULT_OPT = 16 /* ALLOW_CUSTOM_OPTIMISER */ |
    2 /* USE_NEW_FUCTION */ |
    1 /* USE_ES_PARAMS */ |
    4 /* SKIP_NULL_COERCE */ |
    8 /* SKIP_DOMAIN_MEM */;
//| COMPILER_OPT_FLAGS.DEBUG_UNDERRUN;
